import { render, staticRenderFns } from "./ReferralPromotionCreateForm.vue?vue&type=template&id=1a992f50&"
import script from "./ReferralPromotionCreateForm.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports